import React from 'react';
import { useNavigate } from 'react-router-dom';
import { DashboardHeader } from 'features/dashboard/dashboard-header/DashboardHeader';
import { SimpleDashboardContent } from 'features/dashboard/DashboardContent';
import { ChevronLeft, ListTodo } from 'lucide-react';
import { ActivityFeed } from './ActivityFeed';

const ActivityFeedPage: React.FC = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate('/bord');
  };

  return (
    <SimpleDashboardContent>
      <DashboardHeader />

      {/* Header avec bouton retour */}
      <div className="flex items-center gap-3 mb-4">
        <button
          onClick={handleGoBack}
          className="flex items-center gap-1.5 text-sm text-gray-500 hover:text-gray-700 transition-colors"
        >
          <ChevronLeft className="w-4 h-4" />
          <span>Retour</span>
        </button>
      </div>

      {/* Titre de la page */}
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center">
          <ListTodo className="w-5 h-5 text-primary" />
        </div>
        <div>
          <h1 className="text-xl font-semibold text-gray-900">Flux d'activite</h1>
          <p className="text-sm text-gray-500">Historique complet des actions et evenements</p>
        </div>
      </div>

      {/* Activity Feed en mode infinite scroll */}
      <ActivityFeed
        maxItems={20}
        showViewAll={false}
        showHeader={false}
      />
    </SimpleDashboardContent>
  );
};

export default ActivityFeedPage;
